import React from 'react';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';
import { Caption } from '@walmart-web/livingdesign-components';
import { Lock as LockIcon } from '@livingdesign/icons';

import styles from '../styles.module.css';
import StatusCard from '../../../../components/StatusCard/index.tsx';

type Props = {
  status: string;
  deliveryDate?: string;
};

const LockedProductConfirmationCard: React.FC<Props> = ({
  status,
  deliveryDate
}) => {
  const { t } = useTranslation('ihut');

  return (
    <StatusCard
      status={status}
      imgSrc="/assets/images/ihut/shipping.png"
      showTag
      tagProps={{
        leading: <LockIcon />,
        variant: 'tertiary',
        color: 'gray',
        text: t('shippingInfo.notYet')
      }}
    >
      <StatusCard.Heading>
        {t('shippingInfo.productConfirmation')}
      </StatusCard.Heading>
      <StatusCard.Text>{t('shippingInfo.letUsKnow')}</StatusCard.Text>
      {deliveryDate && (
        <StatusCard.Caption>
          <Trans
            t={t}
            i18nKey="shippingInfo.estimatedArrival"
            values={{
              date: moment(deliveryDate).format('MM/DD/YYYY'),
              time: moment(deliveryDate).format('h:mm a')
            }}
          >
            Estimated arrival on{' '}
            <Caption UNSAFE_className={styles.bold}>deliveryDate</Caption> at{' '}
            deliveryTime
          </Trans>
        </StatusCard.Caption>
      )}
    </StatusCard>
  );
};

export default LockedProductConfirmationCard;
